import React from 'react'
import ReactDom from 'react-dom';
import "../node_modules/quill/dist/quill.snow.css"
import "./index.css";
import Auth from './pages/auth';
import Axios from 'axios';

export default function Main() {
  let auth = JSON.parse(localStorage.getItem('authData'));

  if(auth !== null)
  {
    Axios.defaults.headers.common['Authorization'] = `Bearer ${auth.token}`;
  }
  return(
    <Auth />
  )
}

ReactDom.render(<Main />, document.getElementById("root"));